import { jsx } from "react/jsx-runtime";
import { Component } from "@contember/binding";
import { StaticSingleChoiceField } from "./StaticSingleChoiceField.js";
import { DynamicSingleChoiceField } from "./DynamicSingleChoiceField.js";
const isStatic = (props) => Array.isArray(props.options);
const ChoiceField = Component((props) => {
  return isStatic(props) ? /* @__PURE__ */ jsx(StaticSingleChoiceField, { ...props }) : /* @__PURE__ */ jsx(DynamicSingleChoiceField, { ...props });
}, "ChoiceField");
export {
  ChoiceField
};
//# sourceMappingURL=ChoiceField.js.map
